import { addData, setData } from '@/actions/auth';
import {
  addCourseEnroll,
  getCourseDetail,
  getCourseReview,
  getCourseVedio,
} from '@/actions/courses';

import { modifyHelperReducerData } from '@/actions/helperAction';
import { getMockTestList, getMockTestListByPage } from '@/actions/mock-test';
import { setPaymentEditData } from '@/actions/payment';
import { InnerHtmlReadMore } from '@/components/common/read-more';
import CustomCourseCarousel from '@/components/CustomCourseCarousel';
import { timeToMinutes } from '@/helpers/timeHelper';
import useWidth, { IBooleanArgs } from '@/helpers/widthUtil';
import { Button, Col, Menu, Modal, Row } from 'antd';
import React, { FC, createContext, useEffect, useRef, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import Login from '../../home/Login';
import TutorListView from '../../tutor/all-tutors/TutorList';
import CourseReview from '../review/course-review';
import VideoHLS from '../video/index';
import videojs from 'video.js';
import MockTestItem from './mocktest';
import Curriculum from './curriculum/Curriculum';
import ScrollDetector from '@/helpers/ScrollDetector';
import type { MenuProps } from 'antd';
import SkeletonButton from 'antd/lib/skeleton/Button';
import CourseBanner from './CourseBanner';
import DetailsCard from './DetailsCard';

interface IPreviewContents {
  video: string;
  name: string;
}
interface IListData {
  id: number;
  slug: string;
  image: string;
  href: string;
  title: string;
  course: string;
  duration: string;
  full_marks: number;
  pass_mark: number;
  test_type: string;
  subject: string;
  free: boolean;
  total_questions: number;
  is_submitted: boolean;
  is_enrolled: boolean;
}

type CourseDetailsProps = { course: object | any };

const CourseDetailsPage: FC<CourseDetailsProps> = ({ course }) => {
  const [activeTab, setActiveTab] = React.useState<string>('overview');
  const { isMobile, isTablet }: IBooleanArgs = useWidth();

  const [mockTestQuery, setMockTestQuery] = useState({
    page: 1,
    per_page: 5,
    course: course?.slug,
  });

  const dispatch = useDispatch();
  const ref = React.useRef<HTMLSpanElement>();
  const [modalLessonOpen, setModalVideoOpen] = useState<boolean>(false);
  const [video, setVideo] = useState<string>('');
  const [videoSlug, setVideoSlug] = useState<string>('');
  const [videoIndex, setVideoIndex] = useState<number>(0);
  const [clickPreview, setClickPreview] = useState<object>({
    clicked: false,
    videoSlug: {},
  });
  const [viewCallReqModal, setViewCallReqModal] = useState(false);

  const [auth, setAuth] = useState<boolean>(false);
  const [previewContents, setPreviewContents] = useState<Array<IPreviewContents>>(
    []
  );
  const [videoPreviewMode, setVideoPreviewMode] = useState<boolean>(false);
  const [currentActiveMenu, setCurrentActiveMenu] = useState<string>('');
  const [isStickyMenu, setIsStickyMenu] = useState<boolean>(true);
  const [disableScroll, setDisableScroll] = useState<boolean>(false);
  const [menuItems, setMenuItems] = useState<any>([]);
  const [menuLoading, setMenuLoading] = useState<boolean>(true);
  const [showAllTutor, setShowAllTutor] = useState<boolean>(false);
  const modalRef: any = useRef<HTMLDivElement>();

  const { loginModal } = useSelector(
    (state: RootStateOrAny) => state.auth.helperObj
  );
  const {
    courseEnroll,
    loading,
    courseReviews,
    videoLoading,
    videoEnd,
    courseVideo,
    mockTestLanding,
    mockTestMeta,
  } = useSelector((state: RootStateOrAny) => ({
    courseEnroll: state.courses?.courseDetail?.data,
    loading: state?.courses?.courseDetail?.loading,
    courseReviews: state?.courses?.courseReview,
    videoLoading: state?.courses?.videoLoading,
    videoEnd: state?.helperReducer?.videoEnd,
    courseVideo: state.courses.video,
    mockTestLanding: state?.MockTestReducer?.mockTestLanding,
    mockTestMeta: state?.MockTestReducer?.mockTestLanding?.data?.meta,
  }));

  const videoRef = useRef<HTMLVideoElement>(null);

  const clearPreviewState = (): void => {
    setVideoIndex(0);
    dispatch(modifyHelperReducerData({ key: 'videoEnd', value: '' }));
    setVideoPreviewMode(false);
    setVideo('');
  };

  useEffect(() => {
    const perPage: number = 5;
    dispatch(getCourseReview(course.slug, perPage));
    dispatch(modifyHelperReducerData({ key: 'videoEnd', value: '' }));
    const token: string | null = localStorage.getItem('token');
    // dispatch(clearPaymentData())
    if (token) {
      setAuth(true);
    }
    let arr: Array<any> = [];
    course?.subject?.length !== 0 &&
      course?.subject?.map(
        (subj) =>
          subj.chapter?.length !== 0 &&
          subj?.chapter?.map(
            (chap) =>
              chap?.content?.length !== 0 &&
              chap?.content?.map((cont) =>
                cont?.preview === true ? arr.push(cont) : ''
              )
          )
      );
    setPreviewContents(arr);
    return () => {
      setIsStickyMenu(false);
      setModalVideoOpen(false);
      setMockTestQuery({
        page: 1,
        per_page: 5,
        course: course?.slug,
      });
      getMockTestList({
        data: {
          page: 1,
          per_page: 5,
          course: course?.slug,
        },
      });
      setVideoIndex(0);
      setModalVideoOpen(false);
    };
  }, []);

  useEffect(() => {
    dispatch(
      getMockTestList({
        data: {
          ...mockTestQuery,
        },
      })
    );
  }, [mockTestQuery]);

  const getVideo = (
    slug: string,
    name: string,
    preview: boolean,
    toggleSample: boolean
  ) => {
    if (slug && preview) {
      dispatch(getCourseVedio(slug));
      setVideo(name);
      setVideoSlug(slug);
      if (!toggleSample) setModalVideoOpen(true);
    }
    setVideoPreviewMode(true);
    Array.from(document.getElementsByClassName('ant-modal-wrap')).forEach((each) =>
      each.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    );
  };

  const closeVideo = (): void => {
    var vjs = videojs('learnsic-player_html5_api');
    // var myPlayer = videoRef.current;
    setModalVideoOpen(false);
    vjs.pause();
    // myPlayer && myPlayer.pause();
  };

  const addEnroll = (): void => {
    dispatch(
      addCourseEnroll({
        course: course.id,
        content: course?.subject[0]?.chapter[0]?.content[0]?.id,
      })
    );
    window.location.href = `/course/lesson/${course.slug}/?subtab=${course?.subject[0]?.id}&chaptab=${course?.subject[0]?.chapter[0]?.id}&activetab=${course?.subject[0]?.chapter[0]?.content[0]?.id}`;
  };

  useEffect(() => {
    if (course?.slug) {
      dispatch(getCourseDetail(course.slug));
    }
  }, [course]);

  useEffect(() => {
    if (course || courseReviews || mockTestLanding) {
      let temp = [{ title: 'Overview', key: 'overview' }];

      course?.subject?.length > 0 &&
        temp.push({ title: 'Curriculum', key: 'curriculum' });

      (course?.instructor || course?.teachers?.length !== 0) &&
        temp.push({ title: 'Instructor', key: 'instructor' });

      courseReviews?.data?.length !== 0 &&
        temp.push({ title: 'Review', key: 'review' });

      mockTestLanding?.data?.data?.length > 0 &&
        temp.push({ title: 'Mock Test', key: 'mocktest' });
      setMenuItems(temp);
    }
  }, [courseReviews, mockTestLanding]);

  useEffect(() => {
    menuItems?.length && !mockTestLanding?.loading && setMenuLoading(false);
  }, [menuItems]);

  useEffect(() => {
    if (videoEnd === 'success') {
      previewContents.find(
        (each, index) =>
          each?.video === videoSlug &&
          (dispatch(modifyHelperReducerData({ key: 'videoEnd', value: '' })),
          index + 1 < previewContents?.length
            ? (dispatch(getCourseVedio(previewContents[index + 1]['video'])),
              setVideo(previewContents[index + 1]['name']),
              setVideoSlug(previewContents[index + 1]['video']))
            : (setVideo(each['name']), setVideoSlug(each['video'])))
      );
    }
  }, [videoEnd]);

  //to activate and scroll to clicked tab
  useEffect(() => {
    try {
      var elmnt = document.getElementById(currentActiveMenu);
      const y = elmnt.getBoundingClientRect().top + window.scrollY - 200;
      window.scroll({
        top: y,
        behavior: 'smooth',
      });
      elmnt.focus();
      setActiveTab(currentActiveMenu);
    } catch (err) {}

    // const element = document.getElementById(currentActiveMenu);
    // // document.querySelector(`#${currentActiveMenu}`)
    // element.scrollIntoView({
    //   behavior: 'smooth',
    //   block: 'start',
    // });
  }, [currentActiveMenu]);

  const ModalLoginOpen = (): void => {
    dispatch(
      setData({
        name: 'helperObj',
        key: 'loginModal',
        value: !loginModal,
      })
    );
  };

  const onBuyNowClick = (): void => {
    dispatch(setPaymentEditData({ key: 'orders', value: course }));
  };

  // Course sidebar on scroll logic
  const BOTTOM_SIZE: string =
    courseEnroll?.related_courses?.length !== 0 ? '5px' : '-20px';
  const WIDTH_SIZE: string = '250px';

  try {
    if (typeof window !== 'undefined') {
      const learnsicNavbar: HTMLElement | null = document.getElementById('navbar');
      const courseSidebarElements = document.querySelectorAll<HTMLElement>(
        '.course-details-area'
      );
      let courseSidebar: HTMLElement | null;
      if (courseSidebarElements?.length > 0) {
        courseSidebar = courseSidebarElements[0]?.querySelector(
          '.single-details-sidbar'
        );
      } else {
        courseSidebar = null;
      }
      if (!isMobile) {
        window.onscroll = function (e: Event) {
          if (courseSidebar !== null) {
            if (learnsicNavbar.classList.contains('is-sticky')) {
              const courseDetails: HTMLDivElement = document.querySelector(
                '.course-details-page'
              );
              const footerSection: HTMLDivElement =
                document.querySelector('.footer-section ');
              var subtractWidth = screen.height > 768 ? 120 : 380;
              // : (window.outerWidth > 821 && window.outerWidth < 992 ? 480 : 380);
              if (
                courseDetails !== null &&
                footerSection !== null &&
                window.innerHeight + window.scrollY >=
                  courseDetails.offsetHeight +
                    (footerSection.offsetHeight - subtractWidth)
              ) {
                // If footer reaches
                courseSidebar.classList.add('position-absolute');
                courseSidebar.classList.remove('position-fixed');
                courseSidebar.style.top = 'auto';
                courseSidebar.style.bottom = BOTTOM_SIZE;
                // if (isTablet) {
                //   courseSidebar.style.width = WIDTH_SIZE;
                // }
              } else {
                courseSidebar.classList.remove('position-absolute');
                // courseSidebar.classList.add('position-fixed');
                // courseSidebar.style.removeProperty('top');
                // courseSidebar.style.removeProperty('bottom');
                // if (isTablet) {
                //   courseSidebar.style.width = WIDTH_SIZE;
                // }
              }
              courseSidebar.style.marginTop = '80px';
            } else {
              courseSidebar.style.marginTop = '0px';
            }
          }
        };
      } else {
        courseSidebar.classList.remove('position-fixed');
        courseSidebar.classList.remove('position-absolute');
        courseSidebar.style.top = 'auto';
        courseSidebar.style.bottom = BOTTOM_SIZE;
      }
    }
  } catch (e) {}

  const listData: Array<IListData> = [];
  for (let i = 0; i < mockTestLanding?.data?.data?.length; i++) {
    let data = mockTestLanding?.data?.data[i];
    listData.push({
      href: `/mock-test/${
        data?.test_type == 'LISTENING'
          ? 'listening'
          : data?.test_type == 'WRITING'
          ? 'writing'
          : data?.test_type == 'READING'
          ? 'reading'
          : data?.test_type == 'SPEAKING'
          ? 'speaking'
          : 'normal'
      }/${data.slug}`,
      id: data?.id,
      image: data?.image,
      title: data?.title,
      course: data?.course?.name,
      duration: data?.duration && timeToMinutes(data?.duration) + ' Mins',
      full_marks: data?.total_mark,
      pass_mark: data?.pass_mark,
      test_type: data?.test_type,
      subject: data?.subject?.name,
      free: data?.is_free,
      total_questions: data?.total_questions,
      slug: data?.slug,
      is_submitted: data?.has_completed_test,
      is_enrolled: data?.is_enroll,
    });
  }

  const handleScrollAbove = () => {
    setIsStickyMenu(false);
  };

  const handleScrollBelow = () => {
    setIsStickyMenu(true);
  };

  const overviewRef = useRef(null);
  const curriculumRef = useRef(null);
  const instructorRef = useRef(null);
  const reviewRef = useRef(null);
  const mocktestRef = useRef(null);

  useEffect(() => {
    const handleSetActive = (targetRect, key) => {
      // const targetRect = refObj.current.getBoundingClientRect();
      const isInView =
        targetRect.top >= 0 && targetRect.bottom <= window.innerHeight;
      isInView && !disableScroll && setActiveTab(key);
    };

    const handleScroll = () => {
      if (typeof window !== 'undefined' && window.scrollY === 0) {
        setActiveTab('overview');
        setCurrentActiveMenu('overview');
      }

      if (overviewRef.current) {
        const targetRect = overviewRef.current.getBoundingClientRect();
        handleSetActive(targetRect, 'overview');
      }
      if (curriculumRef.current) {
        const targetRect = curriculumRef.current.getBoundingClientRect();
        handleSetActive(targetRect, 'curriculum');
      }
      if (instructorRef.current) {
        const targetRect = instructorRef.current.getBoundingClientRect();
        handleSetActive(targetRect, 'instructor');
      }
      if (reviewRef.current) {
        const targetRect = reviewRef.current.getBoundingClientRect();
        handleSetActive(targetRect, 'review');
      }
      if (mocktestRef.current) {
        const targetRect = mocktestRef.current.getBoundingClientRect();
        handleSetActive(targetRect, 'mocktest');
      }
      // }
    };

    !disableScroll &&
      typeof window !== 'undefined' &&
      window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [disableScroll]);

  const onMenuClick: MenuProps['onClick'] = (e) => {
    setDisableScroll(true);
    setCurrentActiveMenu(e.key);
    setActiveTab(e.key);
    setTimeout(() => setDisableScroll(false), 3000);
  };

  const viewMoreTests = (): void => {
    if (mockTestQuery?.page < mockTestMeta.last_pages) {
      dispatch(
        getMockTestListByPage({
          ...mockTestQuery,
          page: mockTestQuery?.page + 1,
        })
      );
    }
  };
  return (
    <React.Fragment>
      <DetailsContext.Provider
        value={{
          course,
          loading,
          courseEnroll,
          auth,
          isStickyMenu,
          ModalLoginOpen,
          addEnroll,
          onBuyNowClick,
          videoLoading,
          videoPreviewMode,
          courseVideo,
          clearPreviewState,
          videoRef,
          viewCallReqModal,
          setViewCallReqModal,
        }}
      >
        <ScrollDetector
          scrollHeight={200}
          onScrollAbove={handleScrollAbove}
          onScrollBelow={handleScrollBelow}
        />
        <div ref={modalRef}>
          <Modal
            className="preview-video-modal"
            visible={modalLessonOpen}
            onCancel={() => closeVideo()}
            maskClosable={false}
            footer={null}
            title={
              <>
                <div>
                  <small>Course Preview</small>
                </div>
                <span className="d-block">{video}</span>
              </>
            }
            width={700}
            // centered
          >
            {!videoLoading ? (
              <div className="">
                <VideoHLS
                  source={courseVideo?.file}
                  timeoutAction={false}
                  watermark={false}
                />
              </div>
            ) : (
              <div
                className="video-js vjs-theme-forest vjs-big-play-centered"
                style={{ paddingTop: '56.25%', width: '100%' }}
              >
                <div className="videoLoading vjs-big-play-button">
                  {/* <Spin indicator={<LoadingOutlined className='loading-spin' spin />} /> */}
                </div>
              </div>
            )}
            {/* <PreviewContents
            getVideo={getVideo}
            previewContents={previewContents}
            video={video}
            course={course}
          /> */}
          </Modal>
        </div>

        <Modal
          visible={loginModal}
          onCancel={() => {
            ModalLoginOpen();
            dispatch(
              addData({
                key: 'isCurriculumRedirect',
                value: false,
              })
            );
            dispatch(
              addData({
                key: 'courseData',
                value: {},
              })
            );
          }}
          footer={[]}
          maskClosable={false}
          width={450}
        >
          <div className="banner-form">
            <Login is_instructor={false} isLoginPage={false} isModal />
          </div>
        </Modal>

        <section
          id="course-details-wrapper"
          className={`main-wrapper course-details-page ${
            isMobile ? 'mb-2' : 'mb-5'
          }`}
        >
          {!isMobile && <CourseBanner />}
          {/* Course Details */}
          <Row className={`course-details-area ${isMobile ? 'mb-2' : ''}`}>
            <Col span={!isMobile ? 18 : 24} className="pl-0">
              <div className={`course-details-top ${isMobile ? '' : 'py-3'}`}>
                <div className="course-details-nav">
                  {/* details card for mobile view */}
                  <div className="single-details-sidbar d-lg-none d-md-none d-sm-block">
                    <div
                      className="course-details-feature shadow-none"
                      id="myHeader"
                    >
                      <DetailsCard />
                    </div>
                  </div>
                  {isMobile && <CourseBanner />}
                  {/* course details navs */}
                  <div className={`course-tab-list course-details-nav`}>
                    <Menu
                      className={`rounded ${!isStickyMenu ? 'py-2' : ''} ${
                        isStickyMenu || isMobile ? '' : 'custom-container'
                      }`}
                      mode="horizontal"
                      selectedKeys={[activeTab]}
                      onClick={onMenuClick}
                      style={{
                        position:
                          !isStickyMenu &&
                          typeof window !== 'undefined' &&
                          window.scrollY !== 0
                            ? 'fixed'
                            : 'initial',
                        top: !isStickyMenu
                          ? isMobile ||
                            (typeof window !== 'undefined' &&
                              window.outerWidth < 992 &&
                              window.scrollY !== 0)
                            ? '0px'
                            : '95px'
                          : '0px',
                        width: '100%',
                        zIndex: 1000,
                        borderBottom: 'none',
                        right: '0px',
                        left: '0px',
                        overflowX: isMobile ? 'auto' : 'initial',
                        display: 'flex',
                        paddingLeft: !isStickyMenu && isMobile ? '1rem' : '',
                      }}
                      disabledOverflow
                    >
                      {menuItems?.map((each) => (
                        <Menu.Item
                          className={`p-2 ${
                            activeTab === each?.key ? 'ant-menu-item-selected' : ''
                          } ${isMobile ? 'pr-1' : 'pr-5'}`}
                          // onClick={() => {
                          //  setCurrentActiveMenu(each?.key);
                          //   setActiveTab(each?.key);
                          // }}
                          key={each?.key}
                        >
                          {menuLoading ? <SkeletonButton /> : each?.title}
                        </Menu.Item>
                      ))}
                    </Menu>

                    <div id="overview" ref={overviewRef}>
                      <div className="course-desc text-dark">
                        <div className="p-3 border-14 course-description-contents">
                          <InnerHtmlReadMore size={250} text={course?.description} />
                        </div>
                      </div>
                      <div className="course-learn">
                        <div className={`nav-sub-heading ml-2`}>
                          Learning Outcome
                        </div>
                        <div
                          className="p-3 border-14 course-description-contents"
                          dangerouslySetInnerHTML={{ __html: course?.outcome }}
                        ></div>
                      </div>
                      <div className="course-feature">
                        <div className="nav-sub-heading ml-2">
                          Course Requirement
                        </div>
                        <div
                          className="p-3 border-14 course-description-contents"
                          dangerouslySetInnerHTML={{
                            __html: course?.requirement,
                          }}
                        ></div>
                      </div>
                    </div>

                    {course?.subject?.length !== 0 && (
                      <div id="curriculum" ref={curriculumRef}>
                        <Curriculum
                          clickPreview={clickPreview}
                          course={course}
                          getVideo={getVideo}
                          isMobile={isMobile}
                          courseEnroll={courseEnroll}
                          ModalLoginOpen={ModalLoginOpen}
                          auth={auth}
                          cRef={curriculumRef}
                          addEnroll={addEnroll}
                        />
                      </div>
                    )}

                    {(course?.instructor || course?.teachers?.length !== 0) && (
                      <div id="instructor" ref={instructorRef}>
                        <h4 className="text-black pb-2 mt-4">
                          Meet Your Instructors
                        </h4>
                        {course?.teachers?.length !== 0 && (
                          <>
                            <TutorListView
                              tutors={
                                showAllTutor
                                  ? course?.teachers
                                  : course?.teachers?.slice(0, 3)
                              }
                              type="teacher"
                            />
                            {course?.teachers?.length > 3 && (
                              <div className="text-center">
                                <Button
                                  className="btn-secondary border-danger"
                                  onClick={() => setShowAllTutor(!showAllTutor)}
                                >
                                  {showAllTutor ? 'View Less' : 'Load More'}
                                </Button>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}

                    {courseReviews?.data?.length !== 0 && (
                      <div id="review">
                        <h4 className="text-black pb-2 mt-4">
                          What do students say about the course?
                        </h4>
                        <div className="review-tab">
                          <CourseReview
                            courseReview={courseReviews}
                            courseSlug={course?.slug}
                            reviewRef={reviewRef}
                          />
                        </div>
                      </div>
                    )}

                    {mockTestLanding?.data?.data?.length > 0 && (
                      <div id="mocktest" ref={mocktestRef}>
                        <h4 className="text-black pb-2  mt-4">Practice Tests</h4>
                        {listData?.map((item) => (
                          <MockTestItem item={item} key={item?.id} />
                        ))}
                        {mockTestMeta?.current_page == mockTestMeta?.last_pages ? (
                          ''
                        ) : (
                          <div className="text-center">
                            <Button
                              className="btn-secondary border-danger"
                              loading={
                                mockTestLanding?.getMoreMockTestStatus === 'request'
                              }
                              onClick={viewMoreTests}
                            >
                              Load More
                            </Button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* popular course section */}
              {!loading && courseEnroll?.related_courses?.length !== 0 && (
                <div className="border border-muted border-14 mb-30 mt-5 p-3">
                  <div className="container">
                    <h5 className="mb-4" style={{ fontWeight: '500 !important' }}>
                      Other Popular Courses
                    </h5>
                    <div className="row">
                      {/* {
                        courseEnroll?.related_courses?.map((each) =>
                          <div className='col-lg-6 col-md-6 col-sm-12' key={each?.id}>
                          <CourseSingleItem isDetailPage course={each} />
                          </div>
                        )
                      } */}
                      {/* <CustomCarousel courses={courses} /> */}
                      <CustomCourseCarousel
                        courses={courseEnroll?.related_courses}
                        count={isTablet ? 1 : 3}
                        isDetailPage
                      />
                    </div>
                  </div>
                </div>
              )}
            </Col>

            {/* details card for desktop view */}
            <Col
              span={6}
              style={{ top: '-241px' }}
              className="start-learning d-none d-lg-block d-md-block"
            >
              <div className="single-details-sidbar">
                <div className="mb-4 rounded-0" id="myHeader">
                  <DetailsCard />
                </div>
              </div>
            </Col>
          </Row>
        </section>
      </DetailsContext.Provider>
    </React.Fragment>
  );
};

export default CourseDetailsPage;

export const DetailsContext = createContext<any>({});
